import { IPromotionToggle } from '../types';
import { IPublishTermsSuccessPayload } from '../../../../actions/publishTerms';

export function mergeToggle(state: IPromotionToggle, payload: IPublishTermsSuccessPayload): IPromotionToggle {
  return {
    checked: state.changedByUser ? state.checked : payload.dataV2.promotion.toggle.checked,
    disabled: payload.dataV2.promotion.toggle.disabled,
    changedByUser: state.changedByUser,
  };
}
